import { render, staticRenderFns } from "./Articulo_nuevo.vue?vue&type=template&id=8fe6b256"
import script from "./Articulo_nuevo.vue?vue&type=script&lang=js"
export * from "./Articulo_nuevo.vue?vue&type=script&lang=js"
import style0 from "./Articulo_nuevo.vue?vue&type=style&index=0&id=8fe6b256&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports